import { useQuery, UseQueryResult } from '@tanstack/react-query';
import adserver from 'services/adserver';
import { proposalsKeys } from './proposals.keys';
import { Proposal } from './proposals.types';
import { normalizeApiResponse } from './proposals.helpers';

const getProposalsByCommittedBasket = async (
  basketId: number,
): Promise<Proposal[]> => {
  const { data } = await adserver({
    url: `/basket/${basketId}/committed/proposals`,
    headers: {},
  });
  return data.map((proposal: Proposal) => normalizeApiResponse(proposal));
};

export const useGetProposalsByCommittedBasket = (
  basketId: number,
  enabled = true,
): UseQueryResult<Proposal[]> =>
  useQuery<Proposal[]>({
    queryKey: proposalsKeys.committedBasket(basketId),
    queryFn: () => getProposalsByCommittedBasket(basketId),
    enabled: !!basketId && enabled,
  });
